import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import { getOfflineUserByID, getUserByID } from "../../../../Services/User/User";
const ViewSystemUser = ({ isShow,close, editUserId }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [name, setName] = useState(false);
  const [email, setEmail] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [city, setCity] = useState(false);
  const [state, setState] = useState(false);
  const [pincode,setPincode] = useState(false);
  const [address, setAddress] = useState(false);
  const [active, setStatus] = useState("");
  useEffect(() => { 
    setShow(isShow)
     const fetchUserDetails = async (editUserId) => {
          try {
            const response = await getUserByID(editUserId);
            if (response?.status) {
              console.log(response.data.user)
              setName(response.data.user.display_name||"");
              setEmail(response.data.user.email||"")
              setMobile(response.data.user.mobile_number||"");
              setAddress(response.data.user.addresses.address || "")
              if (response.data.user.addresses.states) {
                setState(response.data.user.addresses.states.state_name || "")
              }
              setCity(response.data.user.addresses.city || "")
              setPincode(response.data.user.addresses.pincode || "")
              setStatus(response.data.user.active ? "Active" : "Inactive");


            } else {
              toast.error("Failed to fetch user details");
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
            toast.error("Error fetching user details");
          }
        };
        fetchUserDetails(editUserId);
  }, []); 
  return ( 
    <Modal show={show} onHide={handleClose} >
        <Modal.Header closeButton>
        <h5 className="modal-title">User View</h5>
        </Modal.Header>
        <Modal.Body>  
        <form className="row g-3">
              <div className="col-12 px-3">
                <label for="viewSystemUserName" className="form-label">User Name : {name} </label>
                 <span id="viewSystemUserName"></span>
              </div>
              <div className="col-12 px-3">
                <label for="viewSystemUserEmail" className="form-label" >Email : {email}</label>
                <span id="viewSystemUserEmail"></span>
              </div> 
              <div className="col-12 px-3">
                <label for="viewMobileNo" className="form-label">Mobile Number : {mobile} </label>
                <span id="viewMobileNo"></span>
              </div>
              <div className="col-12 px-3">
                <label for="viewRole" className="form-label">Address : {address}</label>
                <span id="viewRole"></span> 
              </div>
              <div className="col-12 px-3">
                <label for="viewRole" className="form-label">City : {city}</label>
                <span id="viewRole"></span> 
              </div>
              <div className="col-12 px-3">
                <label for="viewRole" className="form-label">State : {state}</label>
                <span id="viewRole"></span> 
              </div>
              <div className="col-12 px-3">
                <label for="viewRole" className="form-label">Pincode : {pincode}</label>
                <span id="viewRole"></span> 
              </div>
              <div className="col-12 px-3">
            <label for="viewRole" className="form-label">Status : {active}</label>
                <span id="viewRole"></span> 
              </div>
            </form> 
        </Modal.Body>
        <Modal.Footer>             
        </Modal.Footer>
      </Modal>
       
  );
};

export default ViewSystemUser;
 